import { render } from "./AddModalTypeFretPaie.vue?vue&type=template&id=2722b0fe&ts=true"
import script from "./AddModalTypeFretPaie.vue?vue&type=script&lang=ts"
export * from "./AddModalTypeFretPaie.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__